"use client";
import React from "react";
import { Modal } from "modules/common/components/Modal/Modal";
import { useSwapLists } from "modules/swap-calculator/stores/useSwapCalculatorStore";
import { useConfirmResetModal } from "modules/swap-calculator/stores/useSwapCalculatorModalsStore";

export function ConfirmResetModal() {
  const { isOpen, setOpen } = useConfirmResetModal();
  // Optimal Zustand selector - only gets reset action
  const { reset } = useSwapLists();

  const handleYes = async () => {
    reset();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      title="Clear trade"
      showCloseButton={true}
      placement="middle"
      actions={
        <>
          <button className="btn btn-outline" onClick={handleClose}>
            No
          </button>
          <button className="btn btn-error" onClick={handleYes}>
            Yes
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-2">
        <p className="text-base-content">
          Are you sure you want to clear the current trade?
        </p>
        <p className="text-secondary text-sm italic">This is irreversible</p>
      </div>
    </Modal>
  );
}
